import React, { FC } from 'react';
import cn from 'classnames';
import { getIframeDocument } from '../../utils/getIframe';
import { handleConfirmation } from '../../dissolve/helpers';
import { usePopupContext } from '../../contexts/Settings';
import { popupLayoutCssPostfix } from '../../types';

type Props = {
  onClick?: () => void;
  id?: string;
  disabled?: boolean;
  className?: string;
};

const OfferDescriptionWrapper: FC<Props> = ({
  className,
  children,
  onClick,
  id = '',
  disabled,
}) => {
  const hoverEffect = () => {
    if (!disabled) {
      const iframe = getIframeDocument();
      const imageOverlay = iframe?.getElementById(id);
      imageOverlay?.classList.add('opacity-50');
    }
  };

  const hoverEffectRemove = () => {
    if (!disabled) {
      const iframe = getIframeDocument();
      const imageOverlay = iframe?.getElementById(id);
      imageOverlay?.classList.remove('opacity-50');
    }
  };

  const { settings } = usePopupContext();
  const popupLayoutCssPostfixValue: string = popupLayoutCssPostfix(settings);

  return (
    <div
      onMouseOver={hoverEffect}
      onMouseOut={hoverEffectRemove}
      onClick={onClick}
      onKeyPress={handleConfirmation(onClick)}
      tabIndex={0}
      className={cn(
        className,
        disabled
          ? `Offer-Description--disabled${popupLayoutCssPostfixValue}`
          : `Offer-Description--enabled${popupLayoutCssPostfixValue}`,
        'text-md',
        `Offer-Description${popupLayoutCssPostfixValue}`,
        'break-words-and-add-overflow-wrap',
        onClick ? 'cursor-pointer' : 'cursor-default',
      )}
    >
      {children}
    </div>
  );
};

export default OfferDescriptionWrapper;
